import api from '@api';
import { call, put, takeEvery } from 'redux-saga/effects';
import { getProductCompletionSheetsListFetchSuccess, getProductCompletionSheetsListFetchFailure } from './reducer';
import { ProductCompletionSheetsListResType } from 'src/types/productCompletionSheetsList';

const getProductCompletionSheetsListFetchRequest = async () => {
    const res = await api('get', 'api/secure/product-completion-sheets');
    return res.data.data;
};

function* getProductCompletionSheetsListFetch(action: { type: string }) {
    try {
        const response: ProductCompletionSheetsListResType = yield call((): any =>
            getProductCompletionSheetsListFetchRequest()
        );
        yield put(getProductCompletionSheetsListFetchSuccess(response));
    } catch (error) {
        yield put(getProductCompletionSheetsListFetchFailure({ error }));
    }
}

export function* getProductCompletionSheetsListFetchWatch() {
    yield takeEvery(
        'productCompletionSheetsList/getProductCompletionSheetsListFetch',
        getProductCompletionSheetsListFetch
    );
}
